import { CalendarBlankIcon as PhosphorCalendarBlankIcon } from "@phosphor-icons/react/dist/ssr/CalendarBlank";

import { createAppIcon } from "@/components/createAppIcon";

export const DateIcon = /* @__PURE__ */ createAppIcon(PhosphorCalendarBlankIcon);
